@if(environment() && !environment()!.production) {
  <div class="py-0.5 bg-gray-700 w-full text-center align-middle text-gray-100 text-xs">NON-PRODUCTION &bull; ONLY USE FICTITIOUS PATIENT INFORMATION</div>
}
